const initialState = {
  bool: false
}

const refreshDataRed = (state = initialState, action) => {
  switch (action.type) {
    case 'REFRESH_DATA' : {
      return {
        ...state,
        bool: action.bool
      }
    }
    default: {
      return state
    }
  }
}

export default refreshDataRed
